// /react/login/login-auth.js


const POST_LOGIN_URL =
  '/post-login';


const AUTH_PROVIDER = Object.freeze({
  CONTADORIA:
    'contadoria',

  GOOGLE:
    'google',

  MICROSOFT:
    'microsoft',
});

function normalizeEmail(
  value
) {
  return String(
    value ||
    ''
  )
    .trim()
    .toLowerCase();
}


function normalizeAuthProvider(
  value
) {
  const provider =
    String(
      value ||
      ''
    )
      .trim()
      .toLowerCase();


  if (
    provider ===
      AUTH_PROVIDER.GOOGLE ||
    provider ===
      AUTH_PROVIDER.MICROSOFT ||
    provider ===
      AUTH_PROVIDER.CONTADORIA
  ) {
    return provider;
  }


  return AUTH_PROVIDER.CONTADORIA;
}


export function isSwitchAccountEntry() {
  return (
    new URLSearchParams(
      window.location.search
    ).get(
      'switch'
    ) === '1'
  );
}



function buildLoginUrl({
  provider =
    AUTH_PROVIDER.CONTADORIA,

  loginHint =
    '',

  mode =
    'login',
} = {}) {
  const qs =
    new URLSearchParams();


  const safeProvider =
    normalizeAuthProvider(
      provider
    );


  const safeMode =
    String(
      mode ||
      'login'
    )
      .trim()
      .toLowerCase();


  const hint =
    normalizeEmail(
      loginHint
    );


  /*
   * Provider je náš vlastní aplikační parametr.
   *
   * Backend ho následně přeloží na Auth0
   * connection.
   */
  qs.set(
    'provider',
    safeProvider
  );


  /*
   * login_hint dává smysl hlavně:
   *
   * - pro vlastní Contadoria účet
   * - pro quick login známého účtu
   *
   * U pickeru Google/Microsoft ho neposíláme,
   * pokud konkrétní účet neznáme.
   */
  if (
    hint &&
    safeMode !==
      'signup'
  ) {
    qs.set(
      'login_hint',
      hint
    );
  }


  qs.set(
    'mode',
    safeMode
  );


  qs.set(
    'returnTo',
    POST_LOGIN_URL
  );


  return (
    '/auth/login?' +
    qs.toString()
  );
}


function startLogin(
  options
) {

  window.location.assign(
    buildLoginUrl(
      options
    )
  );
}


/*
 * =========================================================
 * GOOGLE
 * =========================================================
 */

export function startGooglePicker() {
  startLogin({
    provider:
      AUTH_PROVIDER.GOOGLE,

    mode:
      'select',
  });
}


/*
 * =========================================================
 * MICROSOFT
 * =========================================================
 */


export function startMicrosoftPicker() {
  startLogin({
    provider:
      AUTH_PROVIDER.MICROSOFT,

    mode:
      'select',
  });
}


/*
 * =========================================================
 * CONTADORIA / AUTH0 DATABASE
 * =========================================================
 */

export async function startContadoriaLogin(
  email
) {
  const upn =
    normalizeEmail(
      email
    );


  if (!upn) {
    return {
      ok: false,
      error:
        'invalid_email',
    };
  }


  try {
    const response =
      await fetch(
        '/session/accounts/switch',
        {
          method:
            'POST',

          credentials:
            'include',

          cache:
            'no-store',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',
          },

          body:
            JSON.stringify({
              upn,

              provider:
                AUTH_PROVIDER.CONTADORIA,
            }),
        }
      );


    const data =
      await response
        .json()
        .catch(
          () => null
        );


    if (
      response.ok &&
      data?.ok === true &&
      data?.switched === true
    ) {
      window.location.replace(
        POST_LOGIN_URL
      );


      return {
        ok: true,
        localSession: true,
      };
    }
  } catch (
    error
  ) {
    console.warn(
      '[login] local Contadoria session lookup failed:',
      error
    );
  }


startLogin({
  provider:
    AUTH_PROVIDER.CONTADORIA,

  loginHint:
    upn,

  mode:
    'passkey',
});


  return {
    ok: true,
    localSession: false,
  };
}


export function startContadoriaSignup() {
  startLogin({
    provider:
      AUTH_PROVIDER.CONTADORIA,

    mode:
      'signup',
  });
}


/*
 * =========================================================
 * QUICK LOGIN
 * =========================================================
 */

export async function startQuickLogin(
  account
) {
  const userId =
    Number(
      account?.userId
    );

  const upn =
    normalizeEmail(
      account?.upn
    );

  if (
    !Number.isSafeInteger(userId) ||
    userId <= 0 ||
    !upn
  ) {
    return {
      ok: false,
      error:
        'Neplatný účet.',
    };
  }


  /*
   * 1. Nejprve zkus lokální
   * aplikační session.
   */
  try {
    const response =
      await fetch(
        '/session/accounts/switch',
        {
          method:
            'POST',

          credentials:
            'include',

          cache:
            'no-store',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',
          },

          body:
            JSON.stringify({
              userId,

              provider:
                normalizeAuthProvider(
                  account?.provider
                ),
            }),
        }
      );


    const data =
      await response
        .json()
        .catch(
          () => null
        );


    if (
      response.ok &&
      data?.ok === true &&
      data?.switched === true
    ) {
      window.location.replace(
        POST_LOGIN_URL
      );

      return {
        ok: true,
        localSession:
          true,
      };
    }
  } catch (
    error
  ) {
    console.warn(
      '[login] local session switch failed:',
      error
    );
  }


  /*
   * 2. Lokální session není.
   * Až teď Auth0.
   */
const provider =
  normalizeAuthProvider(
    account?.provider
  );


startLogin({
  provider,

  loginHint:
    upn,

  mode:
    provider ===
        AUTH_PROVIDER.CONTADORIA
      ? 'passkey'
      : 'login',
});


return {
  ok: true,
  localSession:
    false,
};
}


/*
 * =========================================================
 * CURRENT USER
 * =========================================================
 */

export async function getCurrentAuthUser() {
  try {
    const response =
      await fetch(
        '/auth/me',
        {
          credentials:
            'include',

          cache:
            'no-store',

          headers: {
            Accept:
              'application/json',
          },
        }
      );


    if (!response.ok) {
      return null;
    }


    const data =
      await response
        .json()
        .catch(
          () => null
        );


    if (
      data?.ok !== true ||
      !data?.upn
    ) {
      return null;
    }


    return {
      userId:
        Number(
          data.userId
        ) ||
        null,

      upn:
        normalizeEmail(
          data.upn
        ),

      displayName:
        data.displayName ??
        null,

      provider:
        normalizeAuthProvider(
          data.provider
        ),

      img_link:
        data.img_link ??
        null,
    };
  } catch {
    return null;
  }
}


/*
 * =========================================================
 * QUICK ACCOUNTS
 * =========================================================
 */

export async function loadQuickAccounts() {
  try {
    const response =
      await fetch(
        '/session/accounts',
        {
          credentials:
            'include',

          cache:
            'no-store',

          headers: {
            Accept:
              'application/json',
          },
        }
      );


    const data =
      await response
        .json()
        .catch(
          () => null
        );


    if (
      !response.ok ||
      data?.ok !== true
    ) {
      return [];
    }


    return Array.isArray(
      data.accounts
    )
      ? data.accounts
      : [];
  } catch (
    error
  ) {
    console.error(
      '[login] quick accounts load failed:',
      error
    );

    return [];
  }
}

/*
 * =========================================================
 * FORGET ACCOUNT
 * =========================================================
 */

export async function forgetAccount(
  account
) {
  const userId =
    Number(
      account?.userId
    );


  if (
    !Number.isSafeInteger(
      userId
    ) ||
    userId <= 0
  ) {
    throw new Error(
      'invalid_user_id'
    );
  }


  const response =
    await fetch(
      '/session/accounts/forget',
      {
        method:
          'POST',

        credentials:
          'include',

        cache:
          'no-store',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json',
        },

          body:
              JSON.stringify({
                  userId,

                  provider:
                      normalizeAuthProvider(
                          account?.provider
                      ),
              }),
      }
    );


  const data =
    await response
      .json()
      .catch(
        () => null
      );


  if (
    !response.ok ||
    data?.ok !== true
  ) {
    throw new Error(
      data?.error ||
      `HTTP ${response.status}`
    );
  }


  if (
    account?.current !==
      true
  ) {
    return {
      redirected:
        false,
    };
  }


  window.location.assign(
    '/auth/logout'
  );


  return {
    redirected:
      true,
  };
}


/*
 * =========================================================
 * VALIDATION
 * =========================================================
 */

export function validateEmail(
  value
) {
  const email =
    normalizeEmail(
      value
    );


  if (!email) {
    return {
      ok: false,

      email:
        '',

      message:
        'Zadejte e-mail.',
    };
  }


  if (
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      email
    )
  ) {
    return {
      ok: false,

      email,

      message:
        'Zadejte platnou e-mailovou adresu.',
    };
  }


  return {
    ok: true,

    email,

    message:
      '',
  };
}